import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    const chsSection = document.querySelectorAll('.our-team-section');

    // Initialize Swipers
    chsSection.forEach((section) => {
        const chsSlider = section.querySelector('.ots-sldier');
        new Swiper(chsSlider, {
            slidesPerView: 1,
            spaceBetween: 40,
            centeredSlides: true,
            initialSlide: 0,
            navigation: {
                nextEl: section.querySelector('.ots-button-next'),
                prevEl: section.querySelector('.ots-button-prev'),
            },
            breakpoints: {
                992: {
                    slidesPerView: 1.2,
                    initialSlide: 1,
                },
            },
        });
    });
});
